import { useQuery } from "@tanstack/react-query";
import { api } from "../../../singleton/axios";
import { useIsMembershipActive } from "../../../contexts/MembershipContext";
import { ChatQuota } from "../types";

export const chatQuotaQueryKey = ["chat", "quota"] as const;

/** Weekly chat usage — percentages only, never dollars (backend contract). */
export const useChatQuota = () => {
  // Session-derived, NOT the context hook: this quota is also read on routes
  // outside MembershipProvider (account settings' plan panel).
  const { isMembershipActive } = useIsMembershipActive();
  return useQuery<ChatQuota, Error>({
    queryKey: chatQuotaQueryKey,
    enabled: isMembershipActive,
    queryFn: async () => {
      const res = await api.get<ChatQuota>("/chat/quota");
      return res.data;
    },
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
